import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const StyledCloseIcon = styled.div`
    width: ${(props) => props.size}rem;
    height: ${(props) => props.size}rem;
    opacity: 0.6;
    transition: opacity 0.2s;
    filter: invert(${(props) => (props.invert ? 1 : 0)});
    &:hover {
        cursor: pointer;
        opacity: 1;
    }
    display: flex;
    align-items: center;
    justify-content: center;
`

const CloseIcon = ({ invert, handlerClick, size }) => {
    return (
        <div
            onClick={() => {
                handlerClick && handlerClick()
            }}
        >
            <StyledCloseIcon invert={invert} size={size}>
                <StaticImage
                    src="../../images/Icon/closeIcon.png"
                    alt="close"
                />
            </StyledCloseIcon>
        </div>
    )
}

export default CloseIcon
